/* @flow */

import React from 'react'
import Step from 'tve/views/step'

class Loading extends Step {
  sendData = false

  render() {
    return (
      <div className="atp-application">
        <div className="atp-loading__spinner" />
      </div>
    )
  }
}

export default Loading
